export default {
      id: "ic_circle-whatsapp-usage",
      viewBox: "0 0 85 85",
      url: "/" + "images/icons.3.109.2.svg#ic_circle-whatsapp-usage",
      toString: function () {
        return this.url;
      }
    }